import ExcelJS from 'exceljs'

export const autoSizeColumns = (worksheet: ExcelJS.Worksheet): void => {
  const mergedColCells = new Set<string>()

  // ✅ Step 1: Collect addresses of column-merged cells
  const merges = worksheet.model?.merges ?? []
  merges.forEach((mergeRange) => {
    const match = mergeRange.match(/^([A-Z]+)(\d+):([A-Z]+)(\d+)$/)
    if (!match) return

    const [, col1, row1, col2, row2] = match
    const startRow = parseInt(row1, 10)
    const endRow = parseInt(row2, 10)
    const startCol = convertColLetterToColNum(col1)
    const endCol = convertColLetterToColNum(col2)

    if (endCol > startCol) {
      for (let row = startRow; row <= endRow; row++) {
        for (let col = startCol; col <= endCol; col++) {
          const address = `${convertColNumToColLetter(col)}${row}`
          mergedColCells.add(address)
        }
      }
    }
  })

  // ✅ Step 2: Adjust column width
  worksheet.columns.forEach((col) => {
    let maxLength = 5
    if (typeof col.eachCell === 'function') {
      col.eachCell({includeEmpty: true}, (cell) => {
        if (mergedColCells.has(cell.address)) return

        const cellValue = cell.value ? cell.value.toString() : ''
        const fontSize = cell.font?.size ?? 11
        const lines = cellValue.split('\n')
        const longestLineLength = Math.max(...lines.map((line) => line.length))
        const scale = fontSize / 11
        const adjustedLength = longestLineLength * scale

        maxLength = Math.max(maxLength, adjustedLength)
      })
    }

    col.width = Math.ceil(maxLength + 2)
  })
}

// A → 1, B → 2, ..., Z → 26, AA → 27, AB → 28, ...
function convertColLetterToColNum(col: string): number {
  let num = 0
  for (let i = 0; i < col.length; i++) {
    num = num * 26 + (col.charCodeAt(i) - 64)
  }
  return num
}

// 1 → A, 2 → B, ..., 27 → AA
function convertColNumToColLetter(col: number): string {
  let letter = ''
  while (col > 0) {
    const rem = (col - 1) % 26
    letter = String.fromCharCode(65 + rem) + letter
    col = Math.floor((col - 1) / 26)
  }
  return letter
}
